import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { first } from 'rxjs/operators';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { VersionHistory } from 'src/app/shared/models/VersionHistory';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-mongo-sync',
  templateUrl: './mongo-sync.component.html',
  styleUrls: ['./mongo-sync.component.scss'],
  providers: [MessageService, ConfirmationService]
})


export class MongoSyncComponent implements OnInit {
  // Security 
  currentUser: any;
  token: string;
  device: string;
  security: SecurityDocument;

  // CRUD VARIABLES
  versionHistoryDialog: boolean;
  versionHistoryList: VersionHistory[];
  versionHistory: VersionHistory;
  selectedVersionHistoryList: VersionHistory[];
  roleList: any[];
  levelList: any[];
  submitted: boolean;

  // FAKE DATA VARIABLE
  fakeRoleData: any[];
  fakeLevelData: any[];


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService) {

    this.mongoSyncTables = [
      {
        name: 'Santov QA',
        code: 'SQ',
        tables: [
          {
            cname: 'Santov QA | Translations',

          },
          {
            cname: 'Santov QA | Catalogs',

          },
          {
            cname: 'Santov QA | Users',
          }
        ]
      },
      {
        name: 'Santov Prod',
        code: 'SP',
        tables: [
          {
            cname: 'Santov Prod | Translations',

          },
          {
            cname: 'Santov Prod | Catalogs',

          },
          {
            cname: 'Santov Prod | Users',
          }
        ]
      }
    ];
    this.onInitSecurity();
  }

  mongoSyncTables: any[];
  selectedMongoSyncTablesFrom: any;
  selectedMongoSyncTablesTo: any;

  /**
   * The ngOnInit function is a lifecycle hook in Angular that is called after the component has been
   * initialized.
   */
  ngOnInit() {

  }

  filteredMongoSyncTables: any[];

  filterMongoSyncTables() {
    if (this.selectedMongoSyncTablesFrom && this.selectedMongoSyncTablesFrom.cname) {
      const containsQA = this.selectedMongoSyncTablesFrom.cname.toLowerCase().includes('qa');

      this.filteredMongoSyncTables = this.mongoSyncTables.filter(item => {
        const containsQAInName = item.name.toLowerCase().includes('prod');
        return containsQA ? containsQAInName : !containsQAInName;
      });
    } else {
      // Si no se seleccionó nada, mostrar todas las opciones
      this.filteredMongoSyncTables = this.mongoSyncTables;
    }
  }

  filterMongoSyncValue() {
    const searchText = this.selectedMongoSyncTablesFrom.cname.toLowerCase();
    const oppositeSearchText = searchText.includes('qa') ? searchText.replace('qa', 'prod') : searchText.replace('prod', 'qa');
    this.filterMongoSyncTables();

    // Filtramos cada elemento en this.filteredMongoSyncTables
    this.filteredMongoSyncTables = this.filteredMongoSyncTables.map(item => {
      const filteredTables = item.tables.filter(table => {
        const tableName = table.cname.toLowerCase();
        const match = tableName.includes(oppositeSearchText);
        return match;
      });

      // Creamos un nuevo objeto que contiene solo las tablas filtradas
      return {
        ...item,
        tables: filteredTables
      };
    });
  }

  /**
   * The function `onInitSecurity()` checks for a token and device parameter in the URL, and based on
   * their values, either authenticates the user or retrieves security information.
   */
  onInitSecurity() {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.device = params.device;
    });

    if (this.token && this.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else if (!this.token) {
      this.currentUser = this.authenticationService.currentUserValue;
      this.getSecurity(this.currentUser.tokenProfile);
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
      this.getSecurity(this.currentUser.tokenProfile);
    }
  }


  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response data.
   * @param {string} user - The "user" parameter is a string that represents the username or user
   * identifier for authentication. It is typically used to identify the user who is trying to log in or
   * access a certain resource.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity(this.token);
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity` retrieves security information based on a token profile and performs
   * additional actions.
   * @param {string} tokenProfile - The tokenProfile parameter is a string that represents the ID of a
   * security.
   */
  getSecurity(tokenProfile: string) {
    this.apiService.findSecurityById({ "id": tokenProfile }).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
      });
  }

  /**
   * The function "getMongoSync" is a placeholder function in TypeScript.
   */
  getMongoSync() {

  }

  /**
   * The function "updateMongoSync" is used to update data in a MongoDB database synchronously.
   */
  updateMongoSync() {

  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels()` retrieves translated labels from an API and stores them in a
   * map.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': []
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
      });
  }
}
